<template>
  <v-card>
    <v-card-title class="primary white--text">News Feed</v-card-title>
    <v-card-text>
      <v-slide-x-reverse-transition group hide-on-leave>
        <v-card class="mt-4" v-for="(item, index) in items" :key="item.id" :color="item.color">
          <v-img
            class="white--text align-end"
            height="150px"
            :src="'https://loremflickr.com/320/240/paris,brazil?random='+index"
          >
            <v-card-title>{{item.title}}</v-card-title>
          </v-img>

          <v-card-subtitle class="pb-0">Number 10</v-card-subtitle>

          <v-card-text class="text--primary">
            <div>Whitehaven Beach</div>

            <div>Whitsunday Island, Whitsunday Islands</div>
          </v-card-text>
        </v-card>
      </v-slide-x-reverse-transition>
    </v-card-text>
  </v-card>
</template>

<script>
const CARDS = [
  {
    title: "Pre-fab homes"
  },
  {
    title: "Favorite road trips"
  },
  {
    title: "Best airlines"
  }
];

export default {
  props: {
    candidate: Object
  },
  data() {
    return {
      interval: null,
      items: [],
      nonce: 1
    };
  },
  beforeDestroy() {
    this.stop();
  },

  methods: {
    addEvent() {
      let item = this.genItem();

      this.items.unshift({
        id: this.nonce++,
        src: item.src,
        title: item.title
      });

      if (this.nonce > 5) {
        this.items.pop();
      }
    },

    genItem() {
      return CARDS[Math.floor(Math.random() * CARDS.length)];
    },

    start() {
      this.interval = setInterval(this.addEvent, 10000);
    },
    stop() {
      clearInterval(this.interval);
      this.interval = null;
    }
  },
  mounted() {
    this.start();
    this.addEvent();
  }
};
</script>
